import { Context } from "@nuxt/types";

export default function({ app, redirect }: Context) {
  const hasCredential = app.$accessor.clientAccount.hasCredential;
  if (hasCredential) {
    return redirect("/");
  }
  return Promise.resolve();
}
